import { render, staticRenderFns } from "./TfaAnon.vue?vue&type=template&id=6a2edf2c"
import script from "./TfaAnon.vue?vue&type=script&lang=js"
export * from "./TfaAnon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "myra-ui-common/i18n/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fsoftware-engineering%2Fmyracloud-app%2Fuser-management%2Flogin%2Fsrc%2Fcomponents%2Fauthentication%2Ftfa%2FTfaAnon.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./i18n.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Fsoftware-engineering%2Fmyracloud-app%2Fuser-management%2Flogin%2Fsrc%2Fcomponents%2Fauthentication%2Ftfa%2FTfaAnon.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports